<template>
  <div>
    <div>
      <strong class="small">{{ label }}</strong>
      <small class="badge badge-secondary ml-1">já existe hoje</small>
    </div>

    <div class="mt-1">
      <button type="button" class="btn btn-sm scope-option mr-1"
              :class="allCompanies ? 'active' : ''"
              :disabled="disabled"
              @click="$emit('all-companies', true)">Todas as empresas</button>
      <button type="button" class="btn btn-sm scope-option"
              :class="allCompanies ? '' : 'active'"
              :disabled="disabled"
              @click="$emit('all-companies', false)">Selecionar quais</button>
    </div>

    <div v-if="!allCompanies" class="mt-2">
      <div class="d-flex align-items-center mb-1">
        <input v-model="search" class="input form-control form-control-sm mr-2"
               placeholder="Buscar por nome ou CNPJ...">
        <span v-if="!disabled" class="text-nowrap">
          <a class="small pointer" @click="selectAll()">Todas</a>
          <span class="text-muted mx-1">|</span>
          <a class="small text-muted pointer" @click="$emit('cnpjs', [])">Nenhuma</a>
        </span>
      </div>

      <div class="company-list border rounded p-1">
        <p v-if="loading" class="text-center text-muted small my-2 mb-0">Carregando...</p>
        <p v-else-if="filtered.length === 0" class="text-center text-muted small my-2 mb-0">
          Nenhuma empresa encontrada
        </p>
        <label v-for="company in filtered" :key="company.id"
               class="d-flex align-items-center mb-0 px-2 py-1"
               :class="disabled ? '' : 'pointer'">
          <bkps-check-box
              :disabled="disabled"
              :value="selectedCnpjs.includes(company.cnpj)"
              @input="toggle(company.cnpj)"/>
          <span class="small ml-2 text-truncate">{{ company.name }}</span>
          <small class="ml-auto text-muted">{{ company.cnpj }}</small>
        </label>
      </div>

      <small class="text-muted">
        {{ selectedCnpjs.length }} de {{ companies.length }} selecionada(s)
      </small>
    </div>

    <small class="d-block text-muted">{{ hint }}</small>
  </div>
</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'

  export default {
    components: { BkpsCheckBox },
    computed: {
      filtered() {
        const term = this.search.trim().toLowerCase().replace(/[.\-/]/g, '')
        if (!term) return this.companies

        return this.companies.filter(company =>
          company.name.toLowerCase().includes(term) ||
          String(company.cnpj).replace(/[.\-/]/g, '').includes(term))
      }
    },
    created() {
      this.load()
    },
    data: () => ({
      companies: [],
      loading: false,
      search: ''
    }),
    methods: {
      load() {
        this.loading = true
        this.axios.get('companies', { params: { q: { type: ['parent', 'subsidiary'] }, per_page: 10000, meta: false } })
          .then(response => this.companies = response.data || [])
          .catch(e => this.$notify.addError(e))
          .finally(() => this.loading = false)
      },
      selectAll() {
        this.$emit('cnpjs', this.companies.map(company => company.cnpj))
      },
      toggle(cnpj) {
        const next = this.selectedCnpjs.includes(cnpj)
          ? this.selectedCnpjs.filter(current => current !== cnpj)
          : [...this.selectedCnpjs, cnpj]

        this.$emit('cnpjs', next)
      }
    },
    name: 'CompanyScope',
    props: {
      allCompanies: { default: true },
      disabled: { default: false },
      hint: { default: '' },
      label: { default: 'Empresas e filiais' },
      selectedCnpjs: { default: () => [] }
    }
  }
</script>

<style scoped>
  .pointer { cursor: pointer; }
  .company-list { max-height: 11rem; overflow-y: auto; }
  .scope-option { border-radius: 1rem; font-size: 11px; padding: .05rem .6rem; border: 1px solid #ced4da; color: #6c757d; }
  .scope-option.active { border-color: rgba(0, 123, 255, .4); background: rgba(0, 123, 255, .1); color: #007bff; }
</style>
